import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import WebpublicationShareForm from '../../../components/Share/WebpublicationForm';

const mapStateToProps = (state: StoreState) => {
	const { sharePanel } = state;
	const { selection, isOpen, isProcessing, form } = sharePanel;
	return { selection, isOpen, isProcessing, form };
};

export default connect(mapStateToProps)(WebpublicationShareForm);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/WebpublicationForm/index.tsx